import React, { useState } from "react";
import { Modal } from "react-bootstrap";

import AboutUs from "pages/layout/footer/AboutUs";
import TermsAndConditions from "pages/layout/footer/Agb";
import Contact from "pages/layout/footer/Contact";
import FAQ from "pages/layout/footer/Faq";
import Impressum from "pages/layout/footer/Impressum";
import DataPrivacy from "pages/layout/footer/Privacy";

const Footer = () => {
  const [activeComponent, setActiveComponent] = useState(null);
  const [showModal, setShowModal] = useState(false);

  const handleOpenModal = (component) => {
    setActiveComponent(component);
    setShowModal(true);
  };

  const handleCloseModal = () => {
    setShowModal(false);
    setActiveComponent(null);
  };

  const renderComponent = () => {
    const props = { switchTo: handleOpenModal };

    switch (activeComponent) {
      case "about":
        return <AboutUs {...props} />;
      case "terms":
        return <TermsAndConditions {...props} />;
      case "privacy":
        return <DataPrivacy {...props} />;
      case "faq":
        return <FAQ {...props} />;
      case "impressum":
        return <Impressum {...props} />;
      case "contact":
        return <Contact {...props} />;
      default:
        return null;
    }
  };

  return (
    <>
      <footer className="footer">
        <div className="footer-container">
          <div className="footer-layout mt-1">
            <div className="footer-column">
              <button onClick={() => handleOpenModal("contact")}>
                Contact
              </button>
              <button onClick={() => handleOpenModal("impressum")}>
                Imprint
              </button>
            </div>

            <div className="footer-column">
              <button onClick={() => handleOpenModal("faq")}>FAQ</button>
              <button onClick={() => handleOpenModal("about")}>About Us</button>
            </div>

            <div className="footer-column">
              <button onClick={() => handleOpenModal("privacy")}>
                Privacy
              </button>
              <button onClick={() => handleOpenModal("terms")}>
                Terms & Conditions
              </button>
            </div>

            <div className="footer-bottom">© Bambkuss 2025</div>
          </div>
        </div>
      </footer>

      <Modal show={showModal} onHide={handleCloseModal} centered size="lg">
        <Modal.Body
          style={{ padding: "20px", maxHeight: "70vh", overflowY: "auto" }}
        >
          {renderComponent()}
        </Modal.Body>
      </Modal>
    </>
  );
};

export default Footer;